







import { Component, Vue } from 'vue-property-decorator'
import clients from '@/data/clients'

@Component
export default class Clients extends Vue {
  private readonly clients = clients
}
